module Meevo.ChangeTimeZone {
	"use strict";

	export interface IChangeTimeZoneContext {
		update(): void;
	}

	export class ChangeTimeZoneContext implements IChangeTimeZoneContext {

		message: any;
		private zones: any;
		private zonesData: any;
		private locationId: number;
		private startDateTime: Date;
		private localTime: Date;

		constructor(private appSettings: Meevo.Components.Common.IAppSettings,
			private dataService: Meevo.Components.BaseClasses.IDataService,
			private $mdDialog: angular.material.IDialogService,
			protected modalService: Meevo.Components.Modal.IModalService,
			private identityService: Meevo.Components.Common.IIdentityService,
			private $translate: angular.translate.ITranslateService,
			private busyService: Meevo.Components.Busy.IBusyService,
			private redirectHandler: Function,
			protected locationTimeZone: any) {

			this.locationId = this.identityService.current().locationId;


			this.zones = this.dataService.customMethodData(`api/TimeZone/List`, 'Post', { 'WithDetails': true })
				.then((response) => {
					this.startDateTime = new Date();
					this.zonesData = response.data;
					return response;
				});


		}

		onChangeTimeZone(): void {

			var dateTimeNow = new Date();
			if (!this.startDateTime) {
				this.startDateTime = new Date();
			}
			var dateDiff = dateTimeNow.valueOf() - this.startDateTime.valueOf();

			if (this.locationTimeZone) {
				var timeZone: any = _.findWhere(this.zonesData, { id: this.locationTimeZone });
				if (timeZone) {
					this.localTime = new Date((new Date(timeZone.locationTime)).valueOf() + dateDiff);
				}
			}
		}

		update() {
			this.message = '';
			var endPoint = "Location/TimeZone";
			let request = {
				"locationTimeZone": this.locationTimeZone,
				"locationId": this.locationId
			};

			return this.modalService.confirmHandler(`You have selected '${this.locationTimeZone}' timezone and the current time is ${this.localTime.toLocaleString()}.  Is this correct ?`, 0, true).then((d) => {
				if (d) {
					this.busyService.start();
					return this.dataService.update(`${endPoint}`, request)
						.then((response) => {
								return this.$mdDialog.hide();
							}, (reason) => {
								this.message = reason.data.responseStatus.message;
						})
						.finally(() => {
							this.busyService.stop();
						});
				}
			});
		}
	}
}